import { render, staticRenderFns } from "./collectionRateDetaiTarget.vue?vue&type=template&id=2c65c3d6&"
import script from "./collectionRateDetaiTarget.vue?vue&type=script&lang=js&"
export * from "./collectionRateDetaiTarget.vue?vue&type=script&lang=js&"
import style0 from "./collectionRateDetaiTarget.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports